// extracted by mini-css-extract-plugin
export default {"Form":"Forms_Form__ZpxQn","Status":"Forms_Status__WVzr6","DateSpan":"Forms_DateSpan__zsgnd","ProductForm":"Forms_ProductForm__AqqRY"};